import React, { forwardRef } from 'react';
import Proptypes from 'prop-types';
import MaterialTab from '@material-ui/core/Tab';

import clsx from 'clsx';
import { withStyles } from '@material-ui/core';

const StyledTab = withStyles(theme => ({
  root: {
    textTransform: 'none',
    minWidth: 0,
    marginRight: theme.spacing(2.5),
    marginLeft: theme.spacing(2.5),
    padding: 0,
    color: theme.palette.grey[600],
    fontSize: 14,
    fontWeight: 600,
  },
  selected: {
    color: theme.palette.grey[800],
  },
}))(props => <MaterialTab disableRipple {...props} />);

const Tab = forwardRef(function Tab({ label, className, ...restProps }, ref) {
  return <StyledTab className={clsx(className)} ref={ref} {...restProps} label={label} />;
});

Tab.propTypes = {
  className: Proptypes.string,
  label: Proptypes.node.isRequired,
};

Tab.defaultProps = {
  className: null,
};

Tab.displayName = 'Tab';

export default Tab;
